module.exports = __webpack_public_path__ + "img/delete-text.09dfb886.png";